import statuses from '@/store/statuses';
import VuexTypes from '@/store/types/index';
import translations from '@/assets/lang/translations';


const TranslationsTypes = VuexTypes.translations;
export default {


  [TranslationsTypes.TRANSLATIONS]: ({ commit, state }, lang) => {
    state.translations['status'] = statuses.LOADING;
    let data = translations.getTranslations(lang)
    let status = statuses.LOADED;
    commit(TranslationsTypes.TRANSLATIONS, { data, status });
  },
};
